import React from 'react'
/**
 * Converts an SVG string into a JSX element.
 * @param svgString The SVG string to convert.
 * @returns JSX Element or null
 */
export const parseSvgToJsx = svgString => {
  try {
    // Create a DOM parser
    const parser = new DOMParser()
    const doc = parser.parseFromString(svgString, 'image/svg+xml')

    // Get the SVG element
    const svg = doc.querySelector('svg')

    if (!svg) {
      console.error('No SVG element found in the string')
      return null
    }

    // Convert SVG attributes to React props
    const props = {}
    Array.from(svg.attributes).forEach(attr => {
      // Convert attribute names from kebab-case to camelCase for React
      let name = attr.name
      if (name.includes('-')) {
        name = name.replace(/-([a-z])/g, g => g[1].toUpperCase())
      }

      // Handle special cases
      if (name === 'class') name = 'className'

      props[name] = attr.value
    })

    // Create children elements recursively
    const createChildren = node => {
      return Array.from(node.childNodes)
        .map((child, index) => {
          if (child.nodeType === Node.TEXT_NODE) {
            return child.textContent
          }

          if (child.nodeType === Node.ELEMENT_NODE) {
            const element = child
            const childProps = { key: index.toString() }

            Array.from(element.attributes).forEach(attr => {
              let name = attr.name
              if (name.includes('-')) {
                name = name.replace(/-([a-z])/g, g => g[1].toUpperCase())
              }

              if (name === 'class') name = 'className'

              childProps[name] = attr.value
            })

            return React.createElement(
              element.tagName.toLowerCase(),
              childProps,
              ...createChildren(element)
            )
          }

          return null
        })
        .filter(Boolean)
    }

    // Create the SVG element with all its children
    return React.createElement('svg', { ...props }, ...createChildren(svg))
  } catch (error) {
    console.error('Failed to parse SVG:', error)
    return null
  }
}
